/**
 * EquityCommand — Sprint 21.7.2 Domain Command Center.
 * Specialist home for equities. KAIROS framing at top; IRIS data below.
 */
import { useEffect } from 'react';
import { Landmark } from 'lucide-react';
import CommandCenterLayout from '../../components/CommandCenter/CommandCenterLayout.jsx';
import { usePage } from '../../contexts/PageContext.jsx';

export default function EquityCommand() {
  const { setPage } = usePage();
  useEffect(() => { setPage('command-equity'); }, []);
  return (
    <CommandCenterLayout
      domain="equity"
      title="Equity Command"
      icon={<Landmark className="w-5 h-5" />}
      subtitle="Equities · individual names"
    />
  );
}
